import cx from "classnames";
import React from "react";
import { useSelector } from "react-redux";

import {
  BaseState,
  FeatureGate,
  getBooleanFeatureGateEnabled,
  getIsUserSignedIn,
} from "@gamedev-web/gamedev-sdk-core";

import { siteLocationPrefix } from "../../constants";
import * as styles from "./TestConsoleLink.module.css";

export const TestConsoleLink = () => {
  const isSignedIn = useSelector(getIsUserSignedIn);
  const isTestPanelEnabled = useSelector((state: BaseState) =>
    getBooleanFeatureGateEnabled(state, FeatureGate.EnableTestTools)
  );
  const colorStyle = styles.colorStyle;

  if (!isTestPanelEnabled || !isSignedIn) {
    return null;
  }

  return (
    <div className={cx(styles.linkContainer, colorStyle)}>
      <a
        className={cx(styles.link, colorStyle)}
        href={`${siteLocationPrefix}/testconsole`}
        target="_blank"
        rel="noopener noreferrer"
      >
        Test Console
      </a>
    </div>
  );
};
